import { Check, Close } from "@vibe/icons";
import ButtonComponent from "@components/Button";
import { useSyncWizardStep3ViewModel } from "./SyncWizardContext";

export function SyncWizardStep3() {
  const { sharedColumns, unmatchedColumns, isLoading, hasError, onRetry } =
    useSyncWizardStep3ViewModel();

  if (hasError) {
    return (
      <div className="flex flex-col gap-2 justify-center items-center py-8">
        <p className="text-xs text-[#676879] !mb-0">
          We couldn&apos;t load column mapping details for these boards.
        </p>
        <ButtonComponent text="Retry" className="retry-button" onClick={onRetry} />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="sticky top-0 z-20 pb-2 bg-white">
        <p className="text-xs text-[#676879] leading-relaxed !mb-0">
          Columns are matched by name. If a column didn't match, the names differ between boards —
          rename them to match if you'd like to share them.
        </p>
      </div>

      {isLoading && (
        <p className="text-xs text-[#676879] !mb-0">Loading columns for both boards...</p>
      )}

      <div className="grid grid-cols-2 gap-3">
        <div>
          <div className="sticky top-[52px] z-20 bg-white py-1">
            <p className="text-xs font-semibold text-[#323338] !mb-0">
              Sharing <span className="text-[#00c875]">{sharedColumns.length}</span>
            </p>
          </div>
          <div className="flex flex-col divide-y divide-[#f0f0f0] border border-solid border-[#e6e9ef] rounded-lg overflow-hidden">
            {sharedColumns.map((col, index) => (
              <div
                key={`${col.title}-${index}`}
                className="flex items-center gap-2 px-2.5 py-2 border-b-0 border-x-0 border-t-0 border-solid border-[#f0f0f0] bg-white"
              >
                <Check size={16} color="#00c875" />
                <span className="text-xs text-[#323338] truncate">{col.title}</span>
              </div>
            ))}
            {!isLoading && sharedColumns.length === 0 && (
              <div className="px-2.5 py-2 bg-white">
                <span className="text-xs text-[#676879]">
                  No matching columns found between these boards.
                </span>
              </div>
            )}
          </div>
        </div>

        <div>
          <div className="sticky top-[52px] z-20 bg-white py-1">
            <p className="text-xs font-semibold text-[#323338] !mb-0">
              Not sharing <span className="text-[#676879]">{unmatchedColumns.length}</span>
            </p>
          </div>
          <div className="flex flex-col divide-y divide-[#f0f0f0] border border-solid border-[#e6e9ef] rounded-lg overflow-hidden">
            {unmatchedColumns.map((col, index) => (
              <div
                key={`${col.title}-${col.type}-${index}`}
                className="flex items-center gap-2 px-2.5 py-2 border-b-0 border-x-0 border-t-0 border-solid border-[#f0f0f0] bg-white"
              >
                <Close size={12} color="#676879" />
                <span className="text-xs text-[#676879] truncate">{col.title}</span>
              </div>
            ))}
            {!isLoading && unmatchedColumns.length === 0 && (
              <div className="px-2.5 py-2 bg-white">
                <span className="text-xs text-[#676879]">
                  All available columns are matched and ready to share.
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
